import React, { useState } from 'react';

import G1 from './Image/G1.jpg'
import G2 from './Image/G2.jpg'
import G3 from './Image/G3.jpg'
import G4 from './Image/G4.jpg'

import G5  from './Image/G5.jpg'
import G6 from './Image/G6.jpg'

import G7 from './Image/G7.jpg'
import G8 from './Image/G8.jpg'
import G9  from './Image/G9.jpg'
import G10 from './Image/G10.jpg'

import G11 from './Image/G11.jpg'
import G12 from './Image/G12.jpg'
import G13  from './Image/G13.jpg'
import G14 from './Image/G14.jpg'
import G15 from './Image/G15.jpg'
import G16 from './Image/G16.jpg'
import G17 from './Image/G17.jpg'
import G18 from './Image/G18.JPG'
import G19 from './Image/G19.JPG'
import G20 from './Image/G20.JPG'
import G21 from './Image/G21.JPG'
import G22 from './Image/G22.JPG'

//Second season
import H1 from './Image/H1.jpg'
import H2 from './Image/H2.jpg'
import H3 from './Image/H3.jpg'
import H4 from './Image/H4.jpg'
import H5 from './Image/H5.jpg'   
import H6 from './Image/H6.jpg'
import H7 from './Image/H7.jpg'
import H8 from './Image/H8.jpg'
import H9 from './Image/H9.jpg'
import H10 from './Image/H10.jpg'
import H11 from './Image/H11.jpg'
import H12 from './Image/H12.jpg'
import H13 from './Image/H13.jpg'
import H14 from './Image/H14.jpg'
import H15 from './Image/H15.jpg'
import H16 from './Image/H16.jpg'
import H17 from './Image/H17.jpg'
import H18 from './Image/H18.jpg'
import H19 from './Image/H19.jpg'
import H20 from './Image/H20.jpg'
import H21 from './Image/H21.jpg' 
import H22 from './Image/H22.jpg' 
import H23 from './Image/H23.jpg' 
import H24 from './Image/H24.jpg' 
import H25 from './Image/H25.jpg'


const images = {
  '2025-26':[H1, H2, H3, H4, H5, H6, H7, H8, H9, H10, H11, H12, H13, H14, H15, H16, H17, H18, H19, H20, H21, H22, H23, H24, H25],
  '2024-25': [G14,G7,G3,G2, G4,  G1, G6, G5, G8, G9, G10, G11, G12, G13,  G15, G16, G17, G18, G19, G20, G22, G21],
}

const SectionGallery = () => {
  // 🟡 Default to latest year
  const [activeYear, setActiveYear] = useState('2025-26');

  // Sort years so latest shows first
  const sortedYears = Object.keys(images).sort((a, b) => b - a);

  return (
    <section className="text-center justify-center items-center mx-auto m-2 md:my-10">
      <div className="justify-center items-center m-2 mt-8 gap-5">
        <h1 className="text-4xl mb-6 font-bold text-[#3b0067]">Gallery</h1>

        {/* Year Tabs */}
        <div className="flex justify-center mb-6">
          {sortedYears.map((year) => (
            <button
              key={year}
              onClick={() => setActiveYear(year)}
              className={`px-7 py-1 m-2 rounded-md text-sm font-semibold ${
                activeYear === year
                  ? 'bg-[#ffbd00] text-black'
                  : 'bg-[#3b0067] text-white'
              }`}
            >
              {year}
            </button>
          ))}
        </div>

        {/* Gallery Images */}
        <div className="flex flex-wrap gap-5 justify-center">
          {images[activeYear].map((src, index) => (
            <div key={index} className="md:w-1/4 w-full">
              <img
                src={src}
                alt={`Gallery ${activeYear} - ${index + 1}`}
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionGallery;